import { VITE_BASE_URL } from 'config'
export default function getImageURL(path: string) {
  return `${VITE_BASE_URL}${path}`
}